/**
 * Colors of our custom Light Theme
 */
export default {
  skyBlue: {
    base: "#E9FAFF",
    darken1: "#0C8DBC",
    darken2: "#3CA4C9",
  },
  yellow: {
    base: "#FCB543",
    darken1: "#FCB544",
    darken2: "#FFBB2E",
    darken3: "#FCC83F",
  },
  darkGreen: {
    base: "#0C3341",
    darken1: "#03303f",
    darken2: "#051920",
  },
  grey: {
    base: "#707070",
  },
};
